import React from 'react';

function RiskIndicatorChart({ indicators, t }) {
  if (!Array.isArray(indicators) || indicators.length === 0) {
    return (
      <p className="text-gray-500 dark:text-gray-400 text-sm">{t('noRiskIndicators')}</p>
    );
  }

  const normalized = indicators.map((item, index) => {
    const indicator = item?.indicator;
    const name =
      typeof indicator === 'object'
        ? indicator?.name || indicator?.code || `${t('indicatorName')} ${index + 1}`
        : indicator || `${t('indicatorName')} ${index + 1}`;
    const weight = typeof item?.weight === 'number' ? item.weight : 50;
    return { name, weight: Math.min(100, Math.max(5, weight)) };
  });

  return (
    <div className="space-y-3">
      {normalized.map((item, index) => (
        <div key={`${item.name}-${index}`}>
          <div className="flex justify-between text-sm mb-1">
            <span className="text-gray-700 dark:text-gray-300 truncate pr-2">{item.name}</span>
            <span className="text-gray-500 dark:text-gray-400 shrink-0">{item.weight}%</span>
          </div>
          <div className="h-2.5 rounded-full bg-gray-200 dark:bg-gray-700 overflow-hidden">
            <div
              className="h-full rounded-full bg-gradient-to-r from-purple-400 to-indigo-500 transition-all duration-700"
              style={{ width: `${item.weight}%` }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}

export default RiskIndicatorChart;
